"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@app/_context";

import { isAdyenCheckoutEnabled } from "@/config/checkout";

import { useCheckoutContext } from "../Checkout.hooks";
import { checkoutStore } from "../Checkout.store";
import CheckoutTextInput from "../CheckoutTextInput";
import CheckoutAddressHeading from "./CheckoutAddressHeading";
import CheckoutCountrySelect from "./CheckoutCountrySelect";
import CheckoutPhoneNumberInput from "./CheckoutPhoneNumberInput";
import CheckoutToggleDeliveryAddress from "./CheckoutToggleDeliveryAddress";
import CheckoutToggleLine2Address from "./CheckoutToggleLine2Address";

export default function CheckoutAddressFields() {
  const t = useTranslate();
  const marketConfig = useMarket().state.market;
  useCheckoutContext();
  const line2 = checkoutStore((state) => state.address.line2);
  const address = checkoutStore((state) => state.address);
  const hasLine2Address = checkoutStore((state) => state.hasLine2Address);

  if (isAdyenCheckoutEnabled({ marketConfig }) === false) {
    return (
      <>
        <CheckoutAddressHeading />
        <CheckoutCountrySelect name="country" label={t("country")} />
        <CheckoutTextInput
          name="zipCode"
          type="text"
          defaultValue={address.zipCode}
          placeholder={t("zipCode")}
          label={t("zipCode")}
        />
      </>
    );
  }

  return (
    <>
      <CheckoutAddressHeading />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("firstName")}
        name="firstName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("lastName")}
        name="lastName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("email")}
        name="email"
        type="email"
      />
      <CheckoutPhoneNumberInput
        className="max-lg:col-span-2"
        label={t("phoneNumber")}
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("street")}
        name="line1"
        type="text"
      >
        <CheckoutToggleLine2Address
          className="absolute right-4 top-3"
          data-testid="toggle-line2-address"
        >
          {t("addLine2")}
        </CheckoutToggleLine2Address>
      </CheckoutTextInput>
      {(line2 || hasLine2Address) && (
        <CheckoutTextInput
          className="max-lg:col-span-2"
          label={t("co")}
          name="line2"
          type="text"
        />
      )}
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("zipCode")}
        name="zipCode"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("city")}
        name="city"
        type="text"
      />
      <CheckoutCountrySelect name="country" label={t("country")} />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("companyNameIfApplicable")}
        name="company"
        type="text"
      />
      <CheckoutToggleDeliveryAddress className="col-span-2" />
    </>
  );
}
